import { jsx as _jsx } from "react/jsx-runtime";
import { TextFieldsOutlined } from "sprout-ui-icons";
import styled, { css } from "styled-components";
import { PageToolbarItem as BasePageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
import { usePostPageFocus, FocusFrom } from "../PostPageFocusContext";
import { usePostPage } from "../PostPageContext";
const PageToolbarItem = styled(BasePageToolbarItem)`
  ${({ $isFocused  })=>$isFocused && css`
      background: #81ccc4;
    `}
`;
const PostPageToolbarItemNote = ()=>{
    const { disabled  } = usePostPage();
    const [focusFrom] = usePostPageFocus();
    /**
   * NOTE: This block of text is no longer valid, as the implementation has changed,
   * but keeping it for posterity.
   *
   * History of solutions implemented to allow this button to "toggle" the `Note`
   * focus state.
   *
   * 1. `onClick` only
   * This does not work, because `onClick` is not able to capture the
   * `activeElement` correctly. So it becomes a "always" open note button instead.
   *
   * 2. `onClick` and `onMouseDown`
   * Use `onMouseDown` to capture the currently `activeElement`, and if it's the
   * `Note`, prevent `onClick` from firing.
   *
   * This solution works in _most_ scenario, but fails in the scenario where the
   * `Note` "shifts" in size (i.e. from no `min-height` to `min-height`).
   *
   * 3. `onMouseDown` only.
   * `onMouseDown` does not work because it causes `DraftJS` `editOnBlur` function
   * to incorrectly be called when the `Note` editor mounts.
   *
   * 4. back to `onClick` only
   * But this time, add a trick to "delay" editor blur. So that when the mouse
   * button is clicked, the `focusFrom` state is still `FocusFrom.Note`.
   */ if (disabled) return null;
    return /*#__PURE__*/ _jsx(PageToolbarItem, {
        $isFocused: focusFrom === FocusFrom.NOTE,
        icon: TextFieldsOutlined,
        label: "Note",
        action: "FOCUS_NOTE"
    });
};
export default PostPageToolbarItemNote;
